import { List as IList } from 'immutable';

export const selectModalVisibilityAboutUs = (state) =>
  state.iconSelect.get('aboutUsIconSelect', false);
export const selectModalVisibilityProductsAndServices = (state) =>
  state.iconSelect.get('productsAndServicesIconSelect', false);
export const selectIcons = (state) => state.iconSelect.get('icons', IList());
